import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  saveCookies() {
    const d = new Date();
    d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toGMTString();

    document.cookie = 'consents_essentials=1;' + expires + ';path=/';
    document.cookie = 'consents_functional=1;' + expires + ';path=/';
    document.cookie = 'consents_analytics=1;' + expires + ';path=/';

    this.animateOut(this.element, () => {
    }, () => {
      this.element.classList.add('d-none');
    });
  }

  animateIn(target, before, callback) {
    let op = 0.1;
    target.style.opacity = op;
    before();
    let timer = setInterval(function () {
      if (op >= 1) {
        clearInterval(timer);
        callback();
      }
      target.style.opacity = op;
      target.style.filter = 'alpha(opacity=' + op * 100 + ')';
      op += op * 0.1;
    }, 5);
  }

  animateOut(target, before, callback) {
    let op = 1;
    target.style.opacity = op;
    before();
    let timer = setInterval(function () {
      if (op <= 0.1) {
        clearInterval(timer);
        callback();
      }
      target.style.opacity = op;
      target.style.filter = 'alpha(opacity=' + op * 100 + ')';
      op -= op * 0.1;
    }, 5);
  }
}
